if (!customElements.get('scroll-to')) {
  class ScrollTo extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(event) {
      event.preventDefault();

      const anchor = event.target.closest('a');
      if(!anchor) return;

      const target = document.querySelector(anchor.getAttribute('href'));
      if(!target) return;

      target.scrollIntoView();

      // const targetPosition = target.getBoundingClientRect().top;
      // const offsetPosition = targetPosition + document.documentElement.scrollTop ;

      // window.scrollTo({
      //   top: offsetPosition,
      //   behavior: "smooth"
      // });
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }
  }

  customElements.define('scroll-to', ScrollTo);
}